module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_2_preview.08632134.jpg";